export default "__VITE_ASSET__BzMaqFBm__"